import React from 'react';
import { Flex } from '$gstyles/wrapper';
import { dialog } from '$gcomponents/reusables';
import intl from '$gintl';
import { useSelector } from 'react-redux';
import { isEnabled } from '$fbusiness/helpers/util';

interface ShippingItemDistributionProps {
  distributions: Array<any>;
  onChangeQty: Function;
}

const ShippingItemDistribution: React.FC<ShippingItemDistributionProps> = ({
  distributions,
  onChangeQty,
}) => {
  const factory: any = useSelector((state: any) => state.factory.factory);
  const onChangeInput = (e, index, blur) => {
    const value = e.target.value;

    const distribution = distributions[index];
    const maxQty = distribution.maxQty;
    const orderOos =
      distribution.orderOos !== undefined ? distribution.orderOos : isEnabled(factory.settings, 'orderOos');

    if (Number(value) > maxQty && Number(value) !== 0 && !orderOos) {
      e.preventDefault();
      dialog.alert({ message: intl('MESSAGE.DISTRIBUTION_MAX', { max: Math.max(maxQty, 0) }) });
      return;
    }
    const totalQty = distributions.reduce(
      (acc, dist, i) => acc + (i === index ? Number(value) : Number(dist.quantity)),
      0,
    );
    onChangeQty(totalQty, index, value, blur);
  };
  return (
    <div>
      {distributions.map((dist, j) => (
        <Flex className="shipping-dist">
          <div className="name">{dist.short}</div>
          <input
            type="number"
            onFocus={(e) => e.target.select()}
            className="qty"
            value={dist.quantity}
            onBlur={(e) => onChangeInput(e, j, true)}
            onChange={(e) => onChangeInput(e, j, false)}
          />
        </Flex>
      ))}
    </div>
  );
};

export default ShippingItemDistribution;
